import { useState } from 'react'
import { ActionIcon, Modal, Tooltip } from '@mantine/core'
import { MessageChatCircle } from '@untitled-ui/icons-react'

import CommentsList from '@/components/ui/CommentsList'
import useComments from '@/hooks/useComments'

/**
 * Bouton commentaires unifié.
 * - Sans onClick : gère le bouton + la modal en interne
 * - Avec onClick : rend uniquement le bouton, le parent gère l'ouverture
 */
export default function CommentsButton({
    commentableType,
    commentableId,
    onClick = null,
}) {
    const [isOpen, setIsOpen] = useState(false)
    const { comments } = useComments(commentableType, commentableId)
    const count = comments.length

    return (
        <>
            <Tooltip label="Commentaires">
                <div className="relative">
                    <ActionIcon
                        variant="default"
                        size={36}
                        onClick={onClick || (() => setIsOpen(true))}
                    >
                        <MessageChatCircle width={16} height={16} />
                    </ActionIcon>
                    {count > 0 && (
                        <span className="absolute -top-1.5 -right-1.5 bg-blue-500 text-white text-[10px] font-medium rounded-full min-w-[18px] h-[18px] flex items-center justify-center px-1 pointer-events-none">
                            {count}
                        </span>
                    )}
                </div>
            </Tooltip>

            {!onClick && (
                <Modal
                    opened={isOpen}
                    onClose={() => setIsOpen(false)}
                    size="xl"
                    withCloseButton={false}
                    padding={0}
                    styles={{ body: { height: '80vh' } }}
                >
                    <CommentsList
                        commentable_type={commentableType}
                        commentable_id={commentableId}
                        onClose={() => setIsOpen(false)}
                    />
                </Modal>
            )}
        </>
    )
}
